import { render, staticRenderFns } from "./addPessoa.vue?vue&type=template&id=7ccce632&scoped=true&"
import script from "./addPessoa.vue?vue&type=script&lang=js&"
export * from "./addPessoa.vue?vue&type=script&lang=js&"
import style0 from "./addPessoa.vue?vue&type=style&index=0&id=7ccce632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccce632",
  null
  
)

export default component.exports